export default __webpack_public_path__ + "static/Managed-Hover-b75e07f951f630f066e56ff878e87694.svg";